module.exports = __webpack_public_path__ + "media/choosing_a_college/tip04_rollover-1845964c.png";